/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as s } from "../../chunks/tslib.es6.js";
import { property as t } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import { subclass as e } from "../../core/accessorSupport/decorators/subclass.js";
import r from "../support/PublishingInfo.js";
const o = "esri.layers.mixins.PublishableLayer",
  i = Symbol(o);
function n(s) {
  return null != s && "object" == typeof s && i in s;
}
const u = n => {
  var u;
  let a = class extends n {
    constructor() {
      super(...arguments), this[u] = !0;
    }
    get publishingInfo() {
      if (this.destroyed) return null;
      const s = this._get("publishingInfo");
      if (s) return s;
      const t = new r();
      return this._checkPublishingStatus(t), t;
    }
    _checkPublishingStatus(s) {
      const t = 250,
        e = 125;
      let r = 0;
      const o = async t => {
          let n;
          s.updating = !0;
          try {
            n = await this.fetchPublishingStatus();
          } catch (u) {
            n = "unavailable";
          }
          "published" !== n && "unavailable" !== n || ("publishing" === s.status && this.refresh(), i.remove()), s.status = n, s.updating = !1, i.removed || (r = setTimeout(o, t, t + e));
        },
        i = {
          removed: !1,
          remove() {
            this.removed = !0, clearTimeout(r);
          }
        };
      this.when().catch(() => i.remove()), o(t), this.addHandles(i);
    }
  };
  return u = i, s([t({
    readOnly: !0,
    clonable: !1
  })], a.prototype, "publishingInfo", null), a = s([e(o)], a), a;
};
export { u as PublishableLayer, n as isPublishableLayer };